import React from "react";
import { Chart } from "react-google-charts";

const AreaChart = () => {
	const someData = [
		["221810311007@gitam", 80],
		["2Sai Sruthi", 78],
		["Talasila", 88],
		["Satwika", 75],
		["Akhil", 70],
	];
	return (
		<div>
			<h3>Hello from Area Chart</h3>

			<div className="row">
				<div style={{ height: "300px" }} className="col-lg-6">
					<Chart
						width={"100%"}
						height={"100%"}
						chartType="ColumnChart"
						loader={<div>Loading Chart</div>}
						data={[["City", "Updated Avg Score"], ...someData]}
						options={{
							title: "Updated Avg Score of Students",
							chartArea: { width: "50%" },
							hAxis: {
								title: "Updated Avg Score",
							},
							vAxis: {
								title: "City",
							},
						}}
						legendToggle
					/>
				</div>
				<div className="col-lg-6">
					<Chart
						width={"500px"}
						height={"300px"}
						chartType="PieChart"
						loader={<div>Loading Chart</div>}
						data={[
							["Task", "Hours per Day"],
							["Work", 11],
							["Eat", 2],
							["Commute", 2],
							["Watch TV", 2],
							["Sleep", 7],
						]}
						options={{
							title: "My Daily Activities",
						}}
						rootProps={{ "data-testid": "1" }}
					/>
				</div>
			</div>
		</div>
	);
};

export default AreaChart;
